/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumDestinatarioStatoProtocollazione =
  (typeof EnumDestinatarioStatoProtocollazione)[keyof typeof EnumDestinatarioStatoProtocollazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumDestinatarioStatoProtocollazione = {
  IN_LAVORAZIONE: 'IN_LAVORAZIONE',
  SUCCESSO: 'SUCCESSO',
  FALLIMENTO: 'FALLIMENTO',
} as const;
